// src/utils/config.ts
// API URL configuration based on environment

// Validate environment variables in production
if (process.env.NODE_ENV === 'production' && !process.env.REACT_APP_API_URL) {
  throw new Error('REACT_APP_API_URL must be set in production environment');
}

export const API_URL = process.env.REACT_APP_API_URL || (
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:8000'
    : 'https://digitalaim.onrender.com'
);

// Force HTTPS for production URLs (add this code)
const forceHttps = (url: string) => {
    if (process.env.NODE_ENV === 'production' && url.startsWith('http://')) {
      return url.replace('http://', 'https://');
    }
    return url;
  };
  
  export const config = {
    // Use the forced HTTPS version
    API_URL: forceHttps(API_URL),
    
    PRODUCTION_DOMAINS: [
        'digitalaim-frontend.onrender.com',
        'digitalaim.onrender.com',
        'thedigitalaim.com',
        'www.thedigitalaim.com'
    ],
    
    IS_PRODUCTION: process.env.NODE_ENV === 'production',
    
    // These endpoint paths are correct
    endpoints: {
        templates: '/api/templates',
        documents: '/api/documents',
        files: '/api/files',
        analysis: '/api/analyze/pdf',
        ai: '/ai/chat',
        aiExtractField: '/ai/extract-field',
        feedback: '/api/feedback',
        corrections: '/api/corrections',
        auth: {
            login: '/simple-token',
            register: '/api/auth/register',
            profile: '/users/me'
        },
        subscription: {
            status: '/api/subscription/status',
            plans: '/api/subscription/plans',
            startTrial: '/api/subscription/start-trial',
            createCheckout: '/api/subscription/create-checkout-session',
            checkUsage: '/api/subscription/check-usage'
        }
    }
};

// Export default for flexibility in imports
export default config;